import "./banner/Banner.css";
import Banner from "./banner/Banner";
import Who_We_Are from "./who_we_are/Who_We_Are";
import What_We_Do from "./what_we_do/What_We_Do";
import Our_Services from "./our_services/Our_Services";
import Counter from "./counter/Counter";
import Our_Projects from "./our_projects/Our_Projects";
import How_We_Work from "./how_we_work/How_We_Work";
import Testimonials from "./testimonials/Testimonials";
import Why_Choose_Us from "./why_choose_us/Why_Choose_Us";
import Our_Work from "./our_work/Our_Work";

function Home() {
  return (
    <>
      <Banner />      
      <Who_We_Are/>
      <Why_Choose_Us/>
      <What_We_Do/>
      <Our_Services/>
      <Counter/>
      <Our_Projects/>
      <How_We_Work/>
      <Our_Work/>
      <Testimonials/>
    </>
  );
}

export default Home;
